/*eslint no-undef: "error"*/
import { createBrowserHistory } from "history";
export default createBrowserHistory(); 
